import { IItemOrcamento } from "app/types/IItemOrcamento";
import React from "react";
import globalMU from "../../../globalMU";

const estiloCompararProdutos =
  require("./comparar-produtos.module.scss").default;

export type DadosCompararProdutos = {
  Descricao: string;
  Referencia: string;
  Codigo: string;
  Unidade1: string;
  Modelo: string;
  PrecoProdutoFormatado: number;
  DescricaoTipoEntrega: string;
  InputFilial: string;
  QuantidadeEstoqueFormatado: number;
  QuantidadeEstoqueFilial: number;
  QuantidadeEstoqueCD: number;
  QuantidadeEstoqueOutraFilial: number;
  CodigoDoFabricante: string;
  Fornecedor: string;
  Unidade2: string;
  Status: string;
  Classe: string;
  DescricaoDisponibilidade: string;
  FatorConversao: number;
  ComissaoVendaFormatado: string;
  QuantidadeMinimaVendaFormatado: string;
  PreçoAVista: number;
  TextoTecnico: string;
};

export type CompararProdutosProps = {
  dadosCompararProdutos: IItemOrcamento[];
  exibirQuantidadeEstoque: boolean; 
  exibirQuantidadeMinimaVenda: boolean; 
  exibirComissaoVenda: boolean;
};

export const CompararProdutos = (props: CompararProdutosProps) => {
  const Descricao = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Descrição</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador} className={estiloCompararProdutos.destaqueDescricao}>
            {value.Descricao}
          </td>
        ))}
      </tr>
    </>
  );

  const Referencia = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Referência</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.Referencia}</td>
        ))}
      </tr>
    </>
  );

  const Codigo = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Código</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.Codigo}</td>
        ))}
      </tr>
    </>
  );
  const Unidade = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Unidade</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.Unidade1}</td>
        ))}
      </tr>
    </>
  );

  const Modelo = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Modelo</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.Modelo}</td>
        ))}
      </tr>
    </>
  );

  const PrecoUnitario = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Preço Unitário</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>
            {globalMU.formatarValorNumerico(
              value.Preco,
              2,
              true
            )}
          </td>
        ))}
      </tr>
    </>
  );

  const TipoDeEntrega = (
    <>
      {props.dadosCompararProdutos[0].DescricaoTipoEntrega && (
        <tr>
          <td className={estiloCompararProdutos.titulos}>Tipo de Entrega</td>
          {props.dadosCompararProdutos.map((value) => (
            <td key={value.Identificador}>{value.DescricaoTipoEntrega}</td>
          ))}
        </tr>
      )}
    </>
  );

  const FilialDeRetirada = (
    <>
      {props.dadosCompararProdutos[0].FilialRetirada && (
        <tr>
          <td className={estiloCompararProdutos.titulos}>Filial de Retirada</td>
          {props.dadosCompararProdutos.map((value) => (
            <td key={value.Identificador}>{value.FilialRetirada}</td>
          ))}
        </tr>
      )}
    </>
  );

  const QuantidadeDisponivel = (
    <>
      {props.dadosCompararProdutos[0].QuantidadeEstoqueFormatado &&  props.exibirQuantidadeEstoque && (
        <tr>
          <td className={estiloCompararProdutos.titulos}>
            Quantidade Disponível
          </td>
          {props.dadosCompararProdutos.map((value) => (
            <td key={value.Identificador}>
              {globalMU.formatarValorNumerico(
                Number(value.QuantidadeEstoqueFormatado),
                3,
                false
              )}
            </td>
          ))}
        </tr>
      )}
    </>
  );

  const QuantidadeEstoqueFilial = (
    <>
      {props.dadosCompararProdutos[0].QuantidadeEstoqueFilial ? (
        <tr>
          <td className={estiloCompararProdutos.titulos}>
            Quantidade Estoque Filial
          </td>
          {props.dadosCompararProdutos.map((value) => (
            <td key={value.Identificador}>{value.QuantidadeEstoqueFilial}</td>
          ))}
        </tr>
      ) : null}
    </>
  );
  const QuantidadeEstoqueCD = (
    <>
      {props.dadosCompararProdutos[0].QuantidadeEstoqueCD !== undefined ? ( 
        <tr>
          <td className={estiloCompararProdutos.titulos}>
            Quantidade Estoque CD
          </td>
          {props.dadosCompararProdutos.map((value) => (
            <td key={value.Identificador}>{value.QuantidadeEstoqueCD}</td>
          ))}
        </tr>
       ) : null} 
    </>
  );

  const QuantidadeEstoqueOutraFilial = (
    <>
      {props.dadosCompararProdutos[0].QuantidadeEstoqueOutraFilial !== undefined ? (
        <tr>
          <td className={estiloCompararProdutos.titulos}>
            Quantidade Estoque Outras Filiais
          </td>
          {props.dadosCompararProdutos.map((value) => (
            <td key={value.Identificador}>{value.QuantidadeEstoqueOutraFilial}</td>
          ))}
        </tr>
      ) : null}
    </>
  );

  const CodigoDoFabricante = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Código do Fabricante</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.CodigoFabricante}</td>
        ))} 
      </tr>
    </>
  );
  const Fornecedor = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Fornecedor</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.NomeFornecedor}</td>
        ))}
      </tr>
    </>
  );

  const Unidade2 = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>2ª Unidade</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.Unidade}</td>
        ))}
      </tr>
    </>
  );

  const Status = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Status</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.StatusProduto}</td>
        ))}
      </tr>
    </>
  );
  const Classe = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Classe</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.Classe}</td>
        ))}
      </tr>
    </>
  );

  const Disponibilidade = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Disponibilidade</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.DescricaoDisponibilidade}</td>
        ))}
      </tr>
    </>
  );

  const FatorDeConversao = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Fator de Conversão</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.FatorConversao}</td>
        ))}
      </tr>
    </>
  );

  const ComissaoVenda = (
    <>
      {props.exibirComissaoVenda && (
          <tr>
            <td className={estiloCompararProdutos.titulos}>Comissão Venda</td>
            {props.dadosCompararProdutos.map((value) => (
              <td key={value.Identificador}>{value.ComissaoVendaFormatado}</td>
            ))}
          </tr>
        )}
    </>
  );

  const QtdeMinimaDeVenda = (
    <> 
      {props.exibirQuantidadeMinimaVenda && ( 
        <tr>
          <td className={estiloCompararProdutos.titulos}>
            Qtde. Mínima de Venda
          </td>
          {props.dadosCompararProdutos.map((value) => (
            <td key={value.Identificador}
            >
              {/* {value.QuantidadeMinimaVendaFormatado} */}
              {globalMU.formatarValorNumerico(value?.MenorFracaoVenda, 3, false)}
            </td>
          ))}
        </tr>
      )}
    </>
  );

  const PreçoAVista = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Preço a Vista</td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>{value.PrecoAVista}</td>
        ))}
      </tr>
    </>
  );

  const TextoTecnico = (
    <>
      <tr>
        <td className={estiloCompararProdutos.titulos}>Texto Técnico </td>
        {props.dadosCompararProdutos.map((value) => (
          <td key={value.Identificador}>
            <div style={{ whiteSpace: "pre-wrap" }}>
              {value.TextoTecnico}
            </div>
          </td>
        ))}
      </tr>
    </>
  );

  return (
    <div>
      <div className={estiloCompararProdutos.separador} />
      <div
        style={{
          overflowX: "scroll",
        }}
      >
        <table className={estiloCompararProdutos.tabelaCompararProdutos}>
          <tbody>
            {Descricao}
            {Referencia}
            {Codigo}
            {Unidade}
            {Modelo}
            {PrecoUnitario}
            {TipoDeEntrega}
            {FilialDeRetirada}
            {QuantidadeDisponivel}
            {QuantidadeEstoqueFilial}
            {QuantidadeEstoqueCD}
            {QuantidadeEstoqueOutraFilial}
            {CodigoDoFabricante}
            {Fornecedor}
            {Unidade2}
            {Status}
            {Classe}
            {Disponibilidade}
            {FatorDeConversao}
            {ComissaoVenda}
            {QtdeMinimaDeVenda}
            {PreçoAVista}
            {TextoTecnico}
          </tbody>
        </table>
      </div>
      {<section style={{ marginBottom: "100px" }} />}
    </div>
  );
};
